import {Component, OnInit, ViewChild, Output, EventEmitter, Input, HostListener} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ConstantsService} from '../../../../services/constants.service';
import { UserRoleService } from '../services/user-role.service';
import {UrlService} from '../../../../services/url.service';

declare const swal;
declare const toastr;

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.component.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CreateModalComponent implements OnInit {
    @Input() create;
    @Output() onClose = new EventEmitter();
    @ViewChild('form') form: NgForm;

    public disabledSubmit = false;

    constructor(public urlService: UrlService,
                public userRoleService: UserRoleService) {

    }

    ngOnInit() {
        this.urlService.modalOpened.emit();
    }

    close(form: NgForm) {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => this.onClose.emit()
            );
        } else {
            this.onClose.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (form.invalid) return toastr.error('Role name is required.');
        this.disabledSubmit = true;
        let data = form.value;
        const role = this.userRoleService.corporationNumberList.find( role => role.id == data.corporationNumberId) || {};
        data.corporationNumber = role.name;
        this.create(data).subscribe(() => {
            this.updateView('User role created');
            this.onClose.emit();
        });
    }

    updateView(msg: string): void {
        toastr.success(msg);
    }

    corporationsToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.close(this.form), 100);
    }
}





// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/create-modal/create-modal.component.ts